import { Typography } from "@circleco/compass/components/Typography";

import { LivePreview } from "./LivePreview";

interface RecordingScreenProps {
  elapsedTime: number;
}

const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

export const RecordingScreen = ({ elapsedTime }: RecordingScreenProps) => (
  <div className="flex flex-col gap-4">
    <LivePreview>
      <div className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-black/50 px-3 py-1 text-white">
        <span
          data-testid="video-clip-recording-indicator"
          className="size-3 animate-pulse rounded-full bg-red-500"
        />
        <Typography variant="label-sm" color="current">
          {formatTime(elapsedTime)}
        </Typography>
      </div>
    </LivePreview>
  </div>
);
